import React from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import NotiController from "../../../../../services/system/noti/noti-controller";
import FilesApi from "../../../../../services/resource/files-api";
import TableHeader from "../../../../../components/TableHeader";
import Pagination from "../../../../../components/Pagination";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import ServiceItemController from "../../../../../services/system/service-item/service-item-controller";
import Utils from "../../../../../utils/utils";
import ServiceOtherController from "../../../../../services/system/service-other/service-other-controller";
import Dropzone from "react-dropzone";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}
class EditServiceManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imgFile: "",
            serviceImage: "",
            files: [],
            listProduct: [],
            serviceItemResList: [],
            state: "ACTIVE",
            pageNumber: 0,
            pageSize: 50,
            isAllSchool: false,
            gradeId: -1,
            currentClassRoomId: -1,

            yearId: parseInt(getSchoolYear()),
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên sản phẩm",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "price",
                    name: "Giá",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "tax",
                    name: "Thuế",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "action",
                    name: "Hành động",
                    style: {textAlign: "center"},
                    sort: false
                }
            ],


            expiredDay: new Date(),
            productName: "",
            groupId: 0,


            content: "",
            classRoomId: 0,
            listClassRoom: [],
        };
    }

    componentWillMount() {
        this.getAllClass()
        this.getListProduct()
        const [searchparams] = this.props.params;
        let serviceId = searchparams.get("id");
        this.getDetailService(serviceId);
        this.setState({
            serviceId: serviceId,
        });
    }
    getDetailService = (productId) => {
        ServiceOtherController.detail(productId, res => {
            let data = res.data
            if (data.typeObject === "ALL"){
                this.setState({
                    isAllSchool: true,
                });
            }else if (data.typeObject == "GRADE"){
                this.setState({
                    isAllSchool: false,
                    gradeId: data.valueObject
                });
            }else if (data.typeObject == "CLASS"){
                this.setState({
                    isAllSchool: false,
                    currentClassRoomId: parseInt(data.valueObject)
                });
            }
            if (res.success){
                this.setState(data, ()=>{
                    this.showImage()
                })
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }

        })
    };
    getListProduct() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: this.state.productName,
            state: "ACTIVE",
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc"
        };
        ServiceItemController.list(payload, res => {
            this.setState({
                showLoading: false,
                listProduct: res.data.content,
            });
        })
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onEdit = () => {
        let {name} = this.state;
        let typeObject = "ALL";
        let valueObject = "";
        if (this.state.isAllSchool){
            typeObject = "ALL"
        }else {
            if (this.state.currentClassRoomId > 0){
                typeObject = "CLASS";
                valueObject = this.state.currentClassRoomId;
            }else if(this.state.gradeId.indexOf("GRADE") > -1){
                typeObject = "GRADE";
                valueObject = this.state.gradeId;
            }else {
                typeObject = "";
            }
        }
        if (name == "" || name.length < 5){
            toast.error("Tên dịch vụ/hàng hóa phải lớn hơn 5 ký tự");
        }else if (typeObject == ""){
            toast.error("Vui lòng chọn đối tượng áp dụng");
        }else if (this.state.serviceItemResList.length < 1){
            toast.error("Vui lòng thêm sản phẩm");
        }else {
            let listServiceItem = []
            this.state.serviceItemResList.forEach((product) => {
                listServiceItem.push(product.id)
            })
            let payload = {
                "expiredDay": moment(this.state.expiredDay).format("yyyy-MM-DD"),
                "content": this.state.content,
                "yearId": parseInt(getSchoolYear()),
                "name": this.state.name,
                "state": this.state.state,
                "serviceImage": this.state.serviceImage,
                "typeObject": typeObject,
                "valueObject": valueObject,
                "listServiceItem": listServiceItem,
                "id": parseInt(this.state.serviceId),
            }
            ServiceOtherController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-dich-vu-khac');
                    toast.success("Sửa dịch vụ/hàng hóa thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };
    getProductSelect(productId){
        let listSelected = this.state.serviceItemResList;
        this.state.listProduct.forEach((product) => {
            if (product.id == productId){
                let item = listSelected.find(item => item.id === product.id);
                if (typeof item === 'undefined'){
                    listSelected.push(product)
                }
            }
        })
        this.setState({
            serviceItemResList: listSelected
        })
    }
    removeProductSelect(productId){
        let filtered = this.state.serviceItemResList.filter(function(el) { return el.id !== productId; });
        this.setState({
            serviceItemResList: filtered
        })
    }
    showImage(){
        if (this.state.serviceImage.length > 0){
            FilesApi.showFile(this.state.serviceImage, res=>{
                this.setState({
                    imgFile: res
                })
            })
        }
    }
    onUpImage = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    serviceImage: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showImage()
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    render() {
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        let {gradeId, serviceItemResList, header} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="list-service" parentClass="service-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Sửa mới dịch vụ"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>SỬA MỚI DỊCH VỤ</h2>
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tên dịch vụ/Hàng hóa</label>
                                                <input
                                                    placeholder="Nhập tên dịch vụ"
                                                    maxLength={255} type="text"
                                                    className="col-8 form-control shadow-none"
                                                    value={this.state.name}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            name: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mt-2">
                                                <label className="label-item col-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày hết hạn đăng ký</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto  form-control kt-input pd-4-input hei-input"
                                                    selected={this.state.expiredDay === '' ? null : new Date(this.state.expiredDay)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            try {
                                                                this.setState({
                                                                    expiredDay: date,
                                                                })
                                                            }catch (e) {

                                                            }
                                                        }
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Mô tả dịch vụ</label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data={this.state.content}
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                    } }
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Icon hiển thị ở ứng dụng</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onUpImage()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFile} src={this.state.imgFile} />
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload 1</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Đối tượng áp dụng
                                            </div>
                                            <div className="row col-12">
                                                <div className="col-xs-12 col-sm-12 col-md-4 d-flex mb-2">
                                                    <div className="checkbox clearfix mr-5">
                                                        <label>
                                                            <input
                                                                type="checkbox"
                                                                onChange={(e) => {
                                                                    const value = this.state.isAllSchool;
                                                                    this.setState({isAllSchool: !value});
                                                                }}
                                                                checked={this.state.isAllSchool}
                                                            />
                                                            {' '}
                                                            Toàn trường
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-4 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Khối</label>
                                                    <GradeManager
                                                        gradeId={gradeId}
                                                        onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-4 d-flex mb-2">
                                                    <label className="col-4 label-item pl-0">Lớp</label>
                                                    <select
                                                        className="form-control kt-input pd-4-input hei-input"
                                                        value={this.state.currentClassRoomId}
                                                        onChange={(e) => {
                                                            this.state.currentClassRoomId = e.target.value;
                                                            this.setState({
                                                                currentClassRoomId: e.target.value,
                                                                inEditing: true
                                                            })
                                                        }}
                                                    >
                                                        <option value="0">Chọn lớp</option>
                                                        {this.renderClassRoom()}
                                                    </select>
                                                </div>
                                            </div>

                                            <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                                Danh sách sản phẩm/hàng hóa thuộc dịch vụ
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-8 d-flex mb-2">
                                                <label className="col-xs-12 col-sm-12 col-md-4 label-item pl-0">Chọn sản phẩm(<span  style={{color: "red",}}>*</span>)</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listProduct}
                                                    getOptionLabel={option => option.name?option.name:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.productName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên sản phẩm/hàng hóa'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                productName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.productId = -1;
                                                            }else if (val.length>3){
                                                                this.getListProduct()
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.getProductSelect(val?.id);
                                                        }else {
                                                            this.setState({
                                                                productId: -1,
                                                                productName: "",
                                                            })
                                                        }
                                                    }}

                                                />

                                            </div>
                                            <div className="card col-12">
                                                <div className="p-0 mb-3">
                                                    <div className="table-wrapper">
                                                        <table
                                                            className="table table-striped table-data table-responsive table-bordered">
                                                            <table className="table">
                                                                <thead>
                                                                <TableHeader
                                                                    header={header}
                                                                    clickSort={data => {
                                                                    }}
                                                                />
                                                                </thead>
                                                                {!serviceItemResList ||
                                                                serviceItemResList.length == 0 ? (
                                                                    <tbody>
                                                                    <tr>
                                                                        <td colSpan={12}>
                                                                            <div className="text-center">
                                                                                Không có dữ liệu
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    </tbody>
                                                                ) : (
                                                                    <tbody>
                                                                    {serviceItemResList &&
                                                                    serviceItemResList.length > 0 &&
                                                                    serviceItemResList?.map((row, index) => (
                                                                        <tr style={{height: 50}}>
                                                                            <td style={{textAlign: "center"}} scope="row">
                                                                                {" "}
                                                                                {this.state.pageNumber * this.state.pageSize +
                                                                                index +
                                                                                1}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {row.name}
                                                                            </td>
                                                                            <td style={{textAlign: "left"}} scope="row">
                                                                                {Utils.formatMoney(row.price)} VNĐ
                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                {Utils.formatMoney(row.tax)} %                                                                            </td>
                                                                            <td style={{textAlign: "center"}}>
                                                                                <button className="btn btn-action p-2"
                                                                                        title='Xóa học sinh'
                                                                                        style={{cursor: 'pointer'}}
                                                                                        onClick={() => {
                                                                                            this.removeProductSelect(row.id)
                                                                                        }}
                                                                                >
                                                                                    <i className="ti-trash"/>
                                                                                </button>
                                                                            </td>
                                                                        </tr>
                                                                    ))}
                                                                    </tbody>
                                                                )}
                                                            </table>
                                                        </table>
                                                    </div>
                                                    <div className="pagination-right">
                                                        <Pagination
                                                            activePage={this.state.pageNumber}
                                                            itemsCountPerPage={this.state.pageSize}
                                                            totalItemsCount={this.state.totalItem}
                                                            changeHandler={page => this.handleChangePage(page)}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.name == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-dich-vu-khac"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EditServiceManagement)
